<div fxLayout="row"
     class="mat-elevation-z2 file-canvas"
     matTooltip="{{tooltip}}"
     matTooltipPosition="above"
     [ngStyle]="{backgroundColor: state}">
  <span>{{attachment.file.name}} ({{fileSvc.sizeFile(attachment.file.size, true)}})</span>
  <mat-icon *ngIf="! loading && upload?.state === 'DONE'">done</mat-icon>
  <span class="fill-space"></span>
  <mat-icon *ngIf="! upload" color="primary"
            matTooltip="enlever ce fichier à téléverser"
            class="close-button"
            (click)="destroyMe()">close
  </mat-icon>
</div>


